import { APP_INJECTOR } from 'app.module'
import { Title } from '@angular/platform-browser'
import { AlertService } from 'core/alert'
import { ConfirmService } from 'core/confirm'
import { Constants } from 'config'
import { WebviewTimelogService } from 'pages/webview/webview-timelog.service'
import { WebviewLogService } from 'pages/webview/webview-log.service'

export abstract class BaseWebviewPageComponent {
  protected alertService: AlertService
  protected confirmService: ConfirmService
  protected titleService: Title
  protected baseTitle: string = Constants.APP.NAME
  protected timelogService: WebviewTimelogService
  protected logService: WebviewLogService

  protected loading: boolean
  protected scrollTop: number = 0

  constructor() {
    this.titleService = APP_INJECTOR.get(Title)
    this.alertService = APP_INJECTOR.get(AlertService)
    this.confirmService = APP_INJECTOR.get(ConfirmService)
    this.timelogService = APP_INJECTOR.get(WebviewTimelogService)
    this.logService = APP_INJECTOR.get(WebviewLogService)
  }

  ngOnInit() {}

  ngOnDestroy() {}

  protected setTitle(title: string) {
    this.titleService.setTitle(title ? `${ title } - ${ this.baseTitle }` : this.baseTitle)
  }

  protected timelog() {
    this.timelogService.bell(window.location.pathname)
  }

  protected driverEvent(event: string, data = null) {
    this.logService.driverEvent(event, data)
  }

  protected errorEvent(error: string) {
    this.logService.errorEvent(error)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/abstract-components/base-webview-page.component.ts